import React from "react";
import { Category } from "../../../category/types/types";
import { Project } from "../../../project/types/types";
import { SubCategory } from "../../../subcategory/types/types";
import ExperienceFilterPresentation from "../../presentation/experience.filter.presentation/ExperienceFilterPresentation";

interface ExperienceFitlerContainerProps {
  project: Partial<Project>
  category: Partial<Category> | null
  subCategory: Partial<SubCategory> | null
  onCategoryHandler: (category: Partial<Category> | null) => void
  onSubCategoryHandler: (subCategory: Partial<SubCategory> | null) => void
}

const ExperienceFilterContainer: React.FC<ExperienceFitlerContainerProps> = ({
  project,
  category,
  subCategory,
  onCategoryHandler,
  onSubCategoryHandler
}) => {
  return (
    <ExperienceFilterPresentation
      projectId={project._id!}
      categoryId={category?._id!}
      onCategoryHanlder={onCategoryHandler}
      onSubCategoryHandler={onSubCategoryHandler}
    />
  )
}

export default ExperienceFilterContainer
